import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { NavBarLink, NavBarMainLayout } from '../../type';
import { DataSourceService } from '../../../../service/data-source.service';
import { Router } from '@angular/router';
import { isNil } from '../../../../utils/ts-typeguard/is-nil';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-navbar-main',
  templateUrl: './navbar-main.component.html',
  styleUrls: ['navbar-main.component.scss'],
})
export class NavbarMainComponent implements OnInit {
  navbarMainLinks!: NavBarMainLayout[];
  openedMenu: number[] = [];
  showMobileMenu = false;
  currentShowMobileDropDownMenu = '';

  constructor(
    private datasourceService: DataSourceService,
    private router: Router,
    private el: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const navbarMainLinks = JSON.parse(JSON.stringify(this.datasourceService.s3Data.navBarSettings.navbarMain));
    navbarMainLinks.sort((a: NavBarLink, b: NavBarLink) => {
      return a.pos > b.pos ? 1 : -1;
    });
    this.navbarMainLinks = navbarMainLinks;
  }

  doLinkClicked(link: any) {
    this.router.navigate([link]);
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.el.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.closeMenu(event);
    }
  }

  openHideMenuItem($event: MouseEvent, index: number, navbarMainLink: NavBarMainLayout) {
    $event.preventDefault();
    $event.stopPropagation();

    if (navbarMainLink.mainLinks.length === 0) {
      this.router.navigate([navbarMainLink.link], {
        state: { label: navbarMainLink.label, subHead: navbarMainLink.subHead ? navbarMainLink.subHead : '' },
      });
    } else {
      if (this.openedMenu.indexOf(index) > -1) {
        this.closeMenu($event);
      } else {
        // open
        this.openedMenu = [index];
      }
    }
  }

  goto($event: any, link: string, navbarMainLink: NavBarLink | NavBarMainLayout) {
    if (!isNil($event)) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    this.router.navigate([link], {
      state: {
        label: navbarMainLink.label,
        subHead: navbarMainLink.subHead,
      },
    });
    this.closeMenu($event);
  }

  closeMenu($event: MouseEvent) {
    if (!isNil($event)) {
      $event.stopPropagation();
    }
    this.openedMenu = [];
    this.showMobileMenu = false;
    this.currentShowMobileDropDownMenu = '';
    this.cdr.detectChanges();
  }

  onClickLogin() {
    window.location.replace(environment.appUrl);
  }

  onClickShowHideMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  }

  openMobileDropDown($event: MouseEvent, id: any, currentShowMobileDropDownMenu: string) {
    $event.stopPropagation();
    $event.preventDefault();
    if (this.currentShowMobileDropDownMenu === id) {
      this.currentShowMobileDropDownMenu = '';
    } else {
      this.currentShowMobileDropDownMenu = id;
    }
  }
}
